import cn from 'classnames';
import { getTranslation } from '../helpers/utilities';
import { h } from 'preact';
import { useCartContext } from '../context/CartContext';

import { useEffect, useState } from 'preact/hooks';

const QuantitySelector = ({ item, setError }) => {
  const { updateLineItem } = useCartContext();
  const [quantity, setQuantity] = useState(item.quantity);
  const [updatingQuantity, setUpdatingQuantity] = useState(null);

  useEffect(() => {
    if (item.quantity < updatingQuantity) {
      setError(item.quantity);
    }
    setQuantity(item.quantity);
    setUpdatingQuantity(null);
  }, [item]);

  const updateQuantity = value => {
    setUpdatingQuantity(value);
    updateLineItem(item.id, value);
  };

  const Button = ({ children, label, onClick, disabled, classes }) => (
    <button
      class={cn(
        `h-10 w-10 border border-primary-2 text-primary-2 focus:outline-none focus:ring-1 ${classes}`,
        {
          'cursor-default text-grey-3': disabled,
        },
      )}
      type="button"
      aria-label={label}
      onClick={onClick}
      disabled={disabled || updatingQuantity !== null}
    >
      {children}
    </button>
  );

  return (
    <div class="mb-2 flex flex-1 items-stretch sm:mb-1 md:mb-0">
      <Button
        label={getTranslation('general.form.decrement')}
        onClick={() => updateQuantity(quantity - 1)}
        disabled={quantity === 1}
        classes="border-r-0 rounded-tl-full rounded-bl-full"
      >
        -
      </Button>

      <input
        class="type-small hide-arrows inline-block w-11 rounded-none border border-l-0 border-r-0 border-primary-2 bg-cream px-2 text-center text-primary-2"
        type="number"
        name="quantity"
        value={quantity}
        aria-label={getTranslation('general.form.quantity')}
        min="1"
        onInput={e => updateQuantity(e.target.value)}
      />

      <Button
        label={getTranslation('general.form.increment')}
        onClick={() => updateQuantity(quantity + 1)}
        classes="border-l-0 rounded-tr-full rounded-br-full"
      >
        +
      </Button>
    </div>
  );
};

export default QuantitySelector;
